import { initializeApp } from "firebase/app";
import {
  deleteToken,
  getMessaging,
  getToken,
  isSupported,
  onMessage,
  //   onMessage,
} from "firebase/messaging";
import { toast } from "sonner";
// import { Notification as notificationIcon } from "../assets/icons";
import { IoCloseSharp } from "react-icons/io5";
import { GoBell } from "react-icons/go";
import { playstore_img, supportIcon } from "assets";
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_AUTH_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_measurementId,
  //   measurementId: "G-Y582RLVPTR",
};
const firebaseApp = initializeApp(firebaseConfig);
const isFirebaseSupported = async () => {
  const supported = await isSupported(); // imported from 'firebase/messaging'
  console.log(supported, "isSupported");
  return supported ? getMessaging(firebaseApp) : null;
};
const messaging = await isFirebaseSupported();
// console.log(messaging, "Messaging");
const isBrowserSupported = () => {
  return (
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window
  );
};
export const fetchToken = async () => {
  console.log(
    process.env.REACT_APP_VAPID_KEY,
    "process.env.REACT_APP_VAPID_KEY"
  );
  const vapidKey = process.env.REACT_APP_VAPID_KEY;
  let token;
  //requesting permission using Notification API
  const permission = isBrowserSupported()
    ? await Notification.requestPermission()
    : "";
  if (permission === "granted") {
    const registration = await navigator?.serviceWorker.register(
      "../../firebase-messaging-sw.js"
    );
    // Wait for serviceWorker.ready
    await navigator?.serviceWorker?.ready;
    if (vapidKey) {
      token = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration: registration,
      });
    }
    return vapidKey ? token : "Vapid key is missing";
  } else if (permission === "denied") {
    //notifications are blocked
    console.log("You denied for the notification");
  }
};
// Delete FCM token function
export const deleteFcmToken = async () => {
  try {
    // Request the current token
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });
    if (currentToken) {
      // Delete the token
      await deleteToken(messaging);
    } else {
    }
  } catch (error) {
    console.error("Unable to delete FCM token:", error);
  }
};
export const onMessageListener = (listing = () => {}) =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      // console.log(payload, "payload");
      const { title, body, image } = payload.notification;
      toast.custom((t) => (
        <div className="common_notification">
          <img src={image || supportIcon} alt="" />
          <div className="content">
            <h4>{title}</h4>
            <p>{body}</p>
          </div>
          <button onClick={() => toast.dismiss(t)}>
            <IoCloseSharp />
          </button>
        </div>
      ));
      listing();
    });
  });
